import styled from "styled-components";

const ease = "cubic-bezier(0.2, 0.7, 0.2, 1)";

export const MemberCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  /* Room inside the card for the lift and its shadow: the carousel clips
     anything outside its slides. */
  padding: 8px 0 26px;
`;

export const Photo = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  transition: transform 0.8s ${ease};
  ${MemberCardWrapper}:hover & {
    transform: scale(1.05);
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 88%;
  margin-top: -70px;
  padding: 18px 22px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(2, 20, 80, 0.18);
  transition: transform 0.45s ${ease}, box-shadow 0.45s ${ease};
  ${MemberCardWrapper}:hover & {
    transform: translateY(-6px);
    box-shadow: 0 18px 36px rgba(2, 20, 80, 0.28);
  }
  @media (max-width: 768px) {
    padding: 12px;
    margin-top: -40px;
  }
`;

export const Name = styled.div`
  color: #092063;
  font-size: ${(props) => (props.featured ? "2.3rem" : "1.2rem")};
  font-weight: 500;
  line-height: ${(props) => (props.featured ? "2.75rem" : "1.41")};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  :after {
    margin-top: ${(props) => (props.featured ? "16px" : "9px")};
    display: block;
    content: "";
    width: 30px;
    height: 3px;
    background: #0043ff;
    transition: width 0.45s ${ease};
  }
  ${MemberCardWrapper}:hover &:after {
    width: 60px;
  }
  @media (max-width: 768px) {
    font-size: ${(props) => (props.featured ? "1.2rem" : "1rem")};
    line-height: ${(props) => (props.featured ? "1.5rem" : "1.16rem")};
    :after {
      height: 2px;
      margin-top: ${(props) => (props.featured ? "8px" : "6px")};
    }
  }
`;

export const Occupation = styled.div`
  padding-top: ${(props) => (props.featured ? "12px" : "8px")};
  color: #4a5a8a;
  font-size: ${(props) => (props.featured ? "1.5rem" : "0.9rem")};
  line-height: ${(props) => (props.featured ? "1.83rem" : "1.3rem")};
  text-align: center;
  @media (max-width: 768px) {
    padding-top: 6px;
    font-size: ${(props) => (props.featured ? "1rem" : "0.8rem")};
  }
`;

// Tells the visitor the president's card opens the biography.
export const BioHint = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  color: #0043ff;
  font-size: 1.05rem;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  span {
    font-size: 1.4rem;
    line-height: 1;
    transition: transform 0.35s ${ease};
  }
  ${MemberCardWrapper}:hover & span {
    transform: rotate(90deg);
  }
`;
